const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目总结',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]
// const { getProjectTypeName } = require('../projectType')
const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
            typeTitle: this.$store.state.logoType === 1 ? '澄清' : '质疑',
        }
    },
    computed: {
        waitsData() {
            return this.$store.state.bids.waitIdsInfo
        },
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/zlgd/queryGuiDang.do`, { bdGuid: this.waitsData.bdGuid }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.bdInfo.bdName,
                    '标段/包编号': res.data.bdInfo.bdBH,
                    '项目名称': res.data.bdInfo.gcName,
                    '采购编号': res.data.bdInfo.gcBH,
                    '项目类型': res.data.bdInfo.xmLeiXing,
                    '采购方式': res.data.bdInfo.zbFangShi,
                    '项目经理': res.data.bdInfo.projectManagerName,
                    '联系电话': res.data.bdInfo.lianXiRenPhone,
                }
                this.config[3].options.data = {
                    '项目总结': res.data.xmSum,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
